import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem("accessToken");
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user?.is_admin === true;

  // List of routes non-admins are allowed to access
  const allowedPathsForNonAdmin = [
    "/app/tables",
    "/app/event/miqaat-home",
    "/app/miqaat-menu",
    "/app/miqaat-allocation",
    "/app/counter-packing",
    "/app/distribution",
    "/app/leftover-degs",
    "/app/mark-attendance"
  ];

  return (
    <Route
      {...rest}
      render={(props) => {
        const path = props.location.pathname;

        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          );
        }

        if (!isAdmin) {
          const isAllowed = allowedPathsForNonAdmin.some((allowed) =>
            path.startsWith(allowed)
          );

          if (!isAllowed) {
            return <Redirect to="/app/event/miqaat-home" />;
          }
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
